export default "__VITE_ASSET__22b2fd70__"